var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{staticClass:"e-textlabel"},[_vm._v(_vm._s(_vm.headerText)+"*")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }